import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'
import { getIdsFromArray } from '@/utils/utils'
import { adaptTaxonomySkillsToStore } from '@/utils/skills'

export function adaptLPathToApi(lpath = {}) {
  let payload = {
    ...lpath,
    // files: lpath.files, not implemented yet
    content: adaptContentToApi(lpath.content),
    auto_publish_at: lpath.auto_publish_at ? new Date(lpath.auto_publish_at).toISOString() : null,
    skill_dive_collections: lpath.skill_dive_collections
      ? lpath.skill_dive_collections.map((collection) => {
          if (typeof collection === 'string') return collection
          return collection.uuid || collection.id
        })
      : [],
  }
  payload = omitBy(payload, isNil)
  payload.difficulty = lpath.difficulty
  delete payload.next_learning_path_item
  delete payload.taxonomy_skills

  return payload
}

export function adaptLPathToStore(lpath = {}) {
  /// MOCK ///
  lpath.data.access = lpath.data.access ? lpath.data.access : {
    related_passes: []
  }
  ///////////
  const lp = {...lpath.data,
    vendors: getIdsFromArray(lpath.data.vendors),
    instructors: getIdsFromArray(lpath.data.instructors),
    learning_areas: getIdsFromArray(lpath.data.learning_areas),
    categories: getIdsFromArray(lpath.data.categories),
    next_learning_path: lpath.data.next_learning_path ? lpath.data.next_learning_path.id : null,
    next_learning_path_item: lpath.data.next_learning_path_item,
    access: {
      ...lpath.data.access,
      related_passes: lpath.data.access.related_passes
    }
  }

  if (Array.isArray(lpath.data.taxonomy_skills)) {
    lp.taxonomy_skills = adaptTaxonomySkillsToStore(lpath.data.taxonomy_skills)
  }

  return lp
}

export function adaptLPathsToStore(lpaths = []) {
  const lpathList = {
    entries: lpaths.data.results.reduce((acc, course) => {
      acc[course.id] = adaptLPathToStore({
        data: course
      })
      return acc
    }, {}),
    next: lpaths.data.next,
    previous: lpaths.data.previous,
    count: lpaths.data.count,
    results: lpaths.data.results.reduce((acc, lpath) => {
      acc.push(adaptLPathToStore({
        data: lpath
      }))
      return acc
    }, []),
  }
  return lpathList
}

/**
 * delete all fields that we don't need from content
 */
function adaptContentToApi(content) {
  if (!content) return content
  for (let i = 0; i < content.length; i++) {
    let elementA = content[i];
    if (elementA.content && elementA.content.length) {
      for (let j = 0; j < elementA.content.length; j++) {
        let elementB = elementA.content[j];
        Object.keys(elementB).map(key => {
          if (key !== 'uuid' && key !== 'content_type') {
            delete elementB[key]
          }
        })
      }
    }
  }
  return content
}
